/**
 * Language mapping service
 * Provides functions to map countries to languages for chat translation
 */

import { LANGUAGES, COUNTRY_TO_LANGUAGE, DEFAULT_LANGUAGE, Language } from '@/config/languages';

// Re-export types and data for convenience
export type { Language };
export { LANGUAGES as availableLanguages };

/**
 * Get the default language for a given country code
 */
export function getLanguageByCountryCode(countryCode: string): Language {
  const languageCode = COUNTRY_TO_LANGUAGE[countryCode.toUpperCase()];

  if (languageCode) {
    const language = LANGUAGES.find(lang => lang.code === languageCode);
    if (language) {
      return language;
    }
  }

  // Default to English if no mapping found
  return DEFAULT_LANGUAGE;
}

/**
 * Alias for getLanguageByCountryCode
 */
export function getDefaultLanguageForCountry(countryCode: string): Language {
  return getLanguageByCountryCode(countryCode);
}
